/*
 * @Author: bbqin
 * @Date: 2022-01-11 14:44:51
 * @LastEditTime: 2022-01-13 16:06:10
 * @LastEditors: bbqin
 * @Description: 如果我没写，可能我忘了。如果我忘了，可能我没看。如果我没看，可能我没写。
 * @FilePath: \Platform_Front\src\platform\components\CardContainer\store.js
 * (混沌)足够多的方案才能接近真实的结果。
 */
import { BaseStore, hookFactory } from '@platform/template';
import { isObject } from "@platform/api";

class Store extends BaseStore {
    constructor(props) {
        super(props);
        this.name = "cardContainerStore";
    }

    // 数据源
    store = {
        name: '',
        visible: true,
        data: {},
        meta: {},
    };

    /**
         * @description: 复写
         * @param {type}
         * @return:
         */
    getStore(paths) {
        return super.get(paths);
    }

    /**
     * @description: 复写
     * @param {type}
     * @return:
     */
    setStore(paths, value, shouldForceUpdate = true, callback) {
        let res = super.set(paths, value);
        shouldForceUpdate && this.forceUpdate(callback);
        return res;
    }

    /**
    * @description: 设置所有meta
    * @param {type}
    * @return:
    */
    setMeta(meta, id, shouldForceUpdate = true) {
        let name = this.getStore("name");
        id && this.setStore("name", id || name, false);

        // 我觉得这里应该 考虑page上的meta更新
        this.setStore(["meta"], meta, shouldForceUpdate);
    }

    /**
     * @description: 获取所有meta
     * @param {type}
     * @return:
     */
    getMeta = () => {
        let meta = this.getStore("meta");
        return meta;
    };

    /**
     * @description: 是否包含当前meta
     * @param {type}
     * @return:
     */
    _hasMeta(id) {
        let meta = this.getStore("meta") || {};
        if (!id || !isObject(meta[id]) || !meta[id].items) {
            console.warn('not find meta');
            return [];
        }
        if (!meta[id].iscoredataarea || meta[id].iscoredataarea === 'N') {
            console.warn('非配置的核心数据模板');
        }
        return meta[id].items;
    }

    /**
     * @description: 获取id所在视图的meta
     * @param {type}
     * @return:
     */
    getViewMeta(id) {
        let viewMeta = this._hasMeta(id);
        return viewMeta;
    }

    /**
     * @description: 设置数据
     * @param {type}
     * @return:
     */
    setData({ data = {}, shouldForceUpdate = true, callback }) {
        this.setStore(["data"], data, shouldForceUpdate, callback);
    }

    /**
     * regexp 可以是方法 也可以是参数
     * @description: 获取数据
     * @param {type}
     * @return:
     */
    // @infoLog
    getData() {
        let data = this.getStore("data");
        return data || {};
    }

    /**
     * 获取某些项的信息
     */
    getItems(id, keys) {
        let data = this.getStore("data");
        let name = this.getStore("name");
        let meta = this.getViewMeta(id || name);
        if (!meta.length) {
            return [];
        }
        // 转对象
        let keyObj = {};
        keys.forEach(key => {
            keyObj[key] = key;
        });
        // 记录数据
        let res = [];
        meta.forEach(item => {
            let { attrcode } = item;
            if (keyObj[attrcode]) {
                let valueObj = data[attrcode] || {};
                res.push({
                    ...item,
                    value: valueObj.value || '',
                    display: valueObj.display || '',
                });
            }
        });
        return res;
    }

    /**
     * 设置某些项
     * items: [{attrs}]
     * @param {*} id 
     * @param {*} items 
     * @returns 
     */
    setItems(id, items, shouldForceUpdate = true) {
        let data = this.getStore("data");
        let name = this.getStore("name");
        let meta = this.getViewMeta(id || name);
        if (!meta.length) {
            return [];
        }
        // 转对象
        let itemsObj = {};
        items.forEach(item => {
            itemsObj[item.attrcode] = item;
        });
        // 更新数据
        meta.forEach(item => {
            let { attrcode } = item;
            let obj = itemsObj[attrcode];
            if (obj) {
                // 更新模板
                for (let key in obj) {
                    if (key !== 'value' || key !== 'display') {
                        item[key] = obj[key];
                    }
                }

                // 更新数据
                data[attrcode] = {
                    ...data[attrcode],
                    ...(obj || {}),
                };
            }
        });

        this.setData({ data, shouldForceUpdate });
    }

    /**
     * @description: 钩子
     * @param {type} 
     * @return: 
     */
    getHooks = () => {
        // 这样处理的一下 才能报错  方法内部的this 永远指向 实例  否则会指向下面的 {} 对象
        this.getMeta = this.getMeta.bind(this);
        this.setMeta = this.setMeta.bind(this);

        return {
            // 这个是给公共层提供 组件在使用baseComponent 是可以正常运行
            setRef: this.setRef,
            getRef: this.getRef,
            removeRef: this.removeRef,

            // 按路径索引 给内部使用
            getStore: this.getStore.bind(this),
            setStore: this.setStore.bind(this),

            /*-------------------上面的部分------------------*/

            //模板
            getMeta: this.getMeta.bind(this),
            getViewMeta: this.getViewMeta.bind(this),
            setMeta: this.setMeta.bind(this),

            // 数据
            setData: this.setData.bind(this),
            getData: this.getData.bind(this),
            getItems: this.getItems.bind(this),
            setItems: this.setItems.bind(this),
        };
    };
}

export default hookFactory(Store);
